export const CONFIG = {
  "PROJECTNAME": "omz",
  "COMPANYNAME": "OMZ",
  "DFTLNGCODE": "de",
  "URL": "https://api.fbsshop.de",
  "PAYMENTSERVER": "https://stripe.mobiapi.de",
  "VENDORID": "10085002",
  "IMAGEURL": "/images",
  "PAYMENTSYSTEM": false,
  "BANNER": false,
  "BRANDS": false,
  "FLAG_ITEM_ON_HAND": false,
  "MENU_LOGO_BACKGROUND": false,
  "LOGO_LOGIN_BACKGROUND": false,
  "MENU_WHITE_BACKGROUND": false,
  "colors": {
    "primary": "rgb(211,48,55)",
    "primary100": "#F2CECC",
    "light": "rgb(211,48,55)",
    "secondary": "rgb(211,48,55)",
    "dark": "rgb(211,48,55)",
    "siteColor3": "#fff",
    "menuSecondary": "rgb(211,48,55)"
  }
};